<template>
  <span class="text"><slot></slot></span>
</template>

<script>
export default {
  name: "DtText",
  props: {},
  components: {},
};
</script>

<style scoped>
.text {
  margin: 0 4px;
}
</style>
